// realtimeConstants.js
'use strict';

const RealtimeProvider = {
  AGORA: 'agora',
};

const RealtimeFeatureName = {
  LIVESTREAM: 'livestream',
  LIVESTREAM_PREVIEW: 'livestream-preview',
};

const AgoraRealtimeChannelType = {
  MESSAGE: 'message',
  STREAM: 'stream',
};

const RealtimeEvent = {
  LIVESTREAM_SESSION_STARTED: 'livestream.session.started',
  LIVESTREAM_SESSION_UPDATED: 'livestream.session.updated',
  LIVESTREAM_SESSION_EDITED: 'livestream.session.edited',
  LIVESTREAM_SESSION_ENDED: 'livestream.session.ended',
  LIVESTREAM_SHOW_FUNDING_CREATED: 'livestream.show.funding.created',
  LIVESTREAM_SHOW_FUNDING_UPDATED: 'livestream.show.funding.updated',
  LIVESTREAM_SHOW_FUNDING_COMPLETED: 'livestream.show.funding.completed',
  LIVESTREAM_SHOW_FUNDING_ENDED: 'livestream.show.funding.ended',
  LIVESTREAM_SHOW_STARTED: 'livestream.show.started',
  LIVESTREAM_SHOW_PROGRESSED: 'livestream.show.progressed',
  LIVESTREAM_SHOW_UPDATED: 'livestream.show.updated',
  LIVESTREAM_SHOW_COMPLETED: 'livestream.show.completed',
  LIVESTREAM_SHOW_ENDED: 'livestream.show.ended',
  LIVESTREAM_ONE_VS_ONE_INVITATION_CREATED: 'livestream.1v1.invitation.created',
  LIVESTREAM_ONE_VS_ONE_INVITATION_STARTED: 'livestream.1v1.invitation.started',
  LIVESTREAM_ONE_VS_ONE_INVITATION_UPDATED: 'livestream.1v1.invitation.updated',
  LIVESTREAM_ONE_VS_ONE_INVITATION_ENDED: 'livestream.1v1.invitation.ended',
  LIVESTREAM_ONE_VS_N_INVITATION_UPDATED: 'livestream.1vN.invitation.updated',
  LIVESTREAM_ONE_VS_N_INVITATION_ENDED: 'livestream.1vN.invitation.ended',
  LIVESTREAM_CHAT_SENT: 'livestream.chat.sent',
  LIVESTREAM_GIFT_PRELOAD_TRIGGERED: 'livestream.gift.preload.triggered',
  // LIVESTREAM_COMMAND_CREATED: 'livestream.command.created', // create event will interrupt the command history
  LIVESTREAM_COMMAND_STARTED: 'livestream.command.started',
  LIVESTREAM_COMMAND_PAUSED: 'livestream.command.paused',
  LIVESTREAM_COMMAND_COMPLETED: 'livestream.command.completed',
  LIVESTREAM_COMMAND_ENDED: 'livestream.command.ended',
  // LIVESTREAM_TOY_COMMAND_CREATED: 'livestream.toyCommand.created', // create event will interrupt the toyCommand history
  LIVESTREAM_TOY_COMMAND_STARTED: 'livestream.toyCommand.started',
  LIVESTREAM_TOY_COMMAND_PAUSED: 'livestream.toyCommand.paused',
  LIVESTREAM_TOY_COMMAND_COMPLETED: 'livestream.toyCommand.completed',
  LIVESTREAM_TOY_COMMAND_ENDED: 'livestream.toyCommand.ended',
  LIVESTREAM_MENU_COMMAND_UPDATED: 'livestream.menu.command.updated',
  LIVESTREAM_MENU_TOY_COMMAND_UPDATED: 'livestream.menu.toyCommand.updated',
};

const RealtimeEventInformation = {
  [RealtimeEvent.LIVESTREAM_SESSION_STARTED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamSession.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'session',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SESSION_UPDATED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamSession.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'session',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SESSION_EDITED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamSession.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'session',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SESSION_ENDED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamSessionEnded.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'session',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SHOW_FUNDING_CREATED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamShowFunding.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'show',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SHOW_FUNDING_UPDATED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamShowFunding.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'show',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SHOW_FUNDING_COMPLETED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamShowFunding.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'show',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SHOW_FUNDING_ENDED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamShowFundingEnded.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'show',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SHOW_STARTED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamShowFunding.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'show',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SHOW_PROGRESSED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamShowFunding.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'show',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SHOW_UPDATED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamShowFunding.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'show',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SHOW_COMPLETED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamShowFunding.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'show',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_SHOW_ENDED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamShowFunding.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'show',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_ONE_VS_ONE_INVITATION_CREATED]: {
    lazyHandler: async () =>
      (await import('../action/handleOneVsOneInvitation.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'invitationOneVsOne',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_ONE_VS_ONE_INVITATION_STARTED]: {
    lazyHandler: async () =>
      (await import('../action/handleOneVsOneInvitation.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'invitationOneVsOne',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_ONE_VS_ONE_INVITATION_UPDATED]: {
    lazyHandler: async () =>
      (await import('../action/handleOneVsOneInvitation.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'invitationOneVsOne',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_ONE_VS_ONE_INVITATION_ENDED]: {
    lazyHandler: async () =>
      (await import('../action/handleOneVsOneInvitation.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'invitationOneVsOne',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_ONE_VS_N_INVITATION_UPDATED]: {
    lazyHandler: async () =>
      (await import('../action/handleOneVsNInvitation.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'invitationOneVsN',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_ONE_VS_N_INVITATION_ENDED]: {
    lazyHandler: async () =>
      (await import('../action/handleOneVsNInvitation.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'invitationOneVsN',
    batchMsec: 2000,
  },
  [RealtimeEvent.LIVESTREAM_CHAT_SENT]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamChatSent.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'chat',
    batchMsec: 3000,
  },
  [RealtimeEvent.LIVESTREAM_GIFT_PRELOAD_TRIGGERED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamGiftPreloadTriggered.js'))
        .default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'giftPreload',
    batchMsec: 500,
  },
  // [RealtimeEvent.LIVESTREAM_COMMAND_CREATED]: {
  //   lazyHandler: async () =>
  //     (await import('../action/handleLivestreamCommand.js')).default,
  //   featureName: RealtimeFeatureName.LIVESTREAM,
  //   dataRecordName: 'command',
  //   batchMsec: 500,
  // },
  [RealtimeEvent.LIVESTREAM_COMMAND_STARTED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamCommand.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'command',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_COMMAND_PAUSED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamCommand.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'command',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_COMMAND_COMPLETED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamCommandEnded.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'command',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_COMMAND_ENDED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamCommandEnded.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'command',
    batchMsec: 500,
  },
  // [RealtimeEvent.LIVESTREAM_TOY_COMMAND_CREATED]: {
  //   lazyHandler: async () =>
  //     (await import('../action/handleLivestreamCommand.js')).default,
  //   featureName: RealtimeFeatureName.LIVESTREAM,
  //   dataRecordName: 'toyCommand',
  //   batchMsec: 500,
  // },
  [RealtimeEvent.LIVESTREAM_TOY_COMMAND_STARTED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamCommand.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'toyCommand',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_TOY_COMMAND_PAUSED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamCommand.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'toyCommand',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_TOY_COMMAND_COMPLETED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamCommandEnded.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'toyCommand',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_TOY_COMMAND_ENDED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamCommandEnded.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'toyCommand',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_MENU_COMMAND_UPDATED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamMenuCommandUpdated.js')).default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'menuCommand',
    batchMsec: 500,
  },
  [RealtimeEvent.LIVESTREAM_MENU_TOY_COMMAND_UPDATED]: {
    lazyHandler: async () =>
      (await import('../action/handleLivestreamMenuToyCommandUpdated.js'))
        .default,
    featureName: RealtimeFeatureName.LIVESTREAM,
    dataRecordName: 'menuToyCommand',
    batchMsec: 500,
  },
};

const RealtimeServiceConnectionStatus = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
  FAILED: 'failed',
};

export {
  RealtimeProvider,
  RealtimeFeatureName,
  AgoraRealtimeChannelType,
  RealtimeEvent,
  RealtimeEventInformation,
  RealtimeServiceConnectionStatus,
};
